import styled from 'styled-components';

const Wrapper = styled.div`
	overflow: hidden;
	position: relative;
	width: 100%;
`;

export default Wrapper;
